export default __webpack_public_path__ + "static/media/visa.2ef55018.svg";